(function(angular, module) {var studentTagManagerController, studentTagManagerDirective;

studentTagManagerController = function(ModelService, $scope) {
  'ngInject';
  var postTag;
  this.tagMap = {};
  $scope.$watchCollection(((function(_this) {
    return function() {
      return _this.tags;
    };
  })(this)), (function(_this) {
    return function() {
      var i, len, ref, tag;
      _this.tagMap = {};
      ref = _this.tags;
      for (i = 0, len = ref.length; i < len; i++) {
        tag = ref[i];
        _this.tagMap[tag.slug] = _this.tagMap[tag.slug] || {};
        _this.tagMap[tag.slug][tag.value] = tag;
      }
    };
  })(this));
  this.reloadTags = function(slug, search) {
    var params;
    params = {
      slug: slug,
      q: search
    };
    this.searchText = search;
    return ModelService.getModelRelation(this.student, 'tags/available', params).then(this.processResponse);
  };
  this.processResponse = (function(_this) {
    return function(data) {
      var i, len, ref, ref1, type;
      _this.addableTypes = data.addable_types;
      _this.addableMap = {};
      ref = _this.addableTypes;
      for (i = 0, len = ref.length; i < len; i++) {
        type = ref[i];
        _this.addableMap[type.slug] = true;
      }
      _this.selected = data.selected;
      _this.selectedLabel = data.selected_label;
      _this.allTags = data.tags;
      _this.allowNew = (data.exact == null) && ((ref1 = _this.searchText) != null ? ref1.length : void 0) >= 3;
    };
  })(this);
  this.hasTag = function(tag) {
    var ref;
    return ((ref = this.tagMap[tag.slug]) != null ? ref[tag.value] : void 0) != null;
  };
  this.clickTag = function(tag) {
    if (this.hasTag(tag)) {
      return this.removeTag(tag);
    } else {
      return this.addTag(tag);
    }
  };
  this.addTag = function(tag) {
    tag = {
      slug: tag.slug,
      value: tag.value
    };
    return postTag(tag);
  };
  this.createTag = function(name) {
    var tag;
    tag = {
      slug: this.selected,
      name: name
    };
    return postTag(tag).then((function(_this) {
      return function() {
        return _this.search();
      };
    })(this));
  };
  this.removeTag = function(tag) {
    return ModelService.untagModel(this.student, tag).then((function(_this) {
      return function(tag) {
        var index, ref;
        tag = (ref = _this.tagMap[tag.slug]) != null ? ref[tag.value] : void 0;
        index = _this.tags.indexOf(tag);
        if (index >= 0) {
          _this.tags.splice(index, 1);
        }
        return tag;
      };
    })(this));
  };
  this.open = function() {
    return this.reloadTags().then((function(_this) {
      return function() {
        return _this.editing = true;
      };
    })(this));
  };
  this.close = function() {
    return this.editing = false;
  };
  this.search = function(query) {
    return this.reloadTags(this.selected, query);
  };
  this.setTagGrop = function(group) {
    return this.reloadTags(group.slug);
  };
  postTag = (function(_this) {
    return function(tag) {
      return ModelService.tagModel(_this.student, tag).then(function(tag) {
        if (!_this.hasTag(tag)) {
          _this.tags.push(tag);
        }
        return tag;
      });
    };
  })(this);
};

studentTagManagerDirective = function() {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'students/components/studentTagManager',
    scope: {
      tags: '=',
      student: '='
    },
    controller: studentTagManagerController,
    bindToController: true,
    controllerAs: 'ctrl'
  };
};

module.directive('dybStudentTagManager', studentTagManagerDirective);
})(angular, angular.module("dybStudentComponents"));